import CreateCampaignPage from './CreateCampaignPage';

export default CreateCampaignPage;